/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Type of the space
 */
export type SpaceType = (typeof SpaceType)[keyof typeof SpaceType];

export const SpaceType = {
  ROOM: 'Room',
  FLOOR: 'Floor',
} as const;
